"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInterviewAnswerAuthorProperty = exports.interviewAnswerAuthorPropertyDefinition = void 0;
exports.interviewAnswerAuthorPropertyDefinition = {
    view: { label: 'Interviewee' },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'interview-answer-author',
};
const isInterviewAnswerAuthorProperty = (prop) => {
    return prop.name === exports.interviewAnswerAuthorPropertyDefinition.name;
};
exports.isInterviewAnswerAuthorProperty = isInterviewAnswerAuthorProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJ2aWV3LWFuc3dlci1hdXRob3IucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9pbnRlcnZpZXctYW5zd2VyLWF1dGhvci5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHVDQUF1QyxHQUFHO0lBQ3JELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxhQUFhLEVBQUU7SUFDOUIsV0FBVyxFQUFFLEVBQUU7SUFDZixJQUFJLEVBQUUsTUFBTTtJQUNaLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLHlCQUF5QjtDQUNBLENBQUE7QUFJMUIsTUFBTSwrQkFBK0IsR0FBRyxDQUFDLElBQWtCLEVBQXlDLEVBQUU7SUFDM0csT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLCtDQUF1QyxDQUFDLElBQUksQ0FBQTtBQUNuRSxDQUFDLENBQUE7QUFGWSxRQUFBLCtCQUErQixtQ0FFM0MifQ==